import logoSrc from '~/assets/logo_notext.png'
import { BRANDING } from '~/config/branding'

interface Props {
  height: number
}

export function Logo({ height }: Props) {
  return <img src={logoSrc} alt={BRANDING.productName} style={{ height, width: 'auto' }} />
}
